import { useEffect } from 'react';
import { useAuth } from '@/contexts/AuthContext';

declare global {
  interface Window {
    OneSignalDeferred?: Array<(OneSignal: any) => void>;
  }
}

/**
 * Syncs the current user's Supabase id as the OneSignal external_id
 * for targeted push delivery. OneSignal itself is initialized via the
 * CDN snippet in index.html.
 */
export const useOneSignal = () => {
  const { user } = useAuth();

  useEffect(() => {
    if (typeof window === 'undefined') return;
    let cancelled = false;
    window.OneSignalDeferred = window.OneSignalDeferred || [];
    window.OneSignalDeferred.push(async (OneSignal: any) => {
      if (cancelled) return;
      try {
        if (user?.id) {
          await OneSignal.login(user.id);
        } else {
          await OneSignal.logout();
        }
      } catch (err) {
        console.error('[OneSignal] identity sync failed', err);
      }
    });
    return () => {
      cancelled = true;
    };
  }, [user?.id]);
};

export default useOneSignal;
